/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoalRequest
 */
export interface GoalRequest {
    /**
     * 
     * @type {string}
     * @memberof GoalRequest
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoalRequest
     */
    goalResult: string;
    /**
     * 
     * @type {Date}
     * @memberof GoalRequest
     */
    achievementDate: Date;
}

/**
 * Check if a given object implements the GoalRequest interface.
 */
export function instanceOfGoalRequest(value: object): value is GoalRequest {
    if (!('goalResult' in value) || value['goalResult'] === undefined) return false;
    if (!('achievementDate' in value) || value['achievementDate'] === undefined) return false;
    return true;
}

export function GoalRequestFromJSON(json: any): GoalRequest {
    return GoalRequestFromJSONTyped(json, false);
}

export function GoalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'goalResult': json['goalResult'],
        'achievementDate': (new Date(json['achievementDate'])),
    };
}

export function GoalRequestToJSON(json: any): GoalRequest {
    return GoalRequestToJSONTyped(json, false);
}

export function GoalRequestToJSONTyped(value?: GoalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'goalResult': value['goalResult'],
        'achievementDate': `${value['achievementDate'].getFullYear()}-${String(value['achievementDate'].getMonth()+1).padStart(2,'0')}-${String(value['achievementDate'].getDate()).padStart(2,'0')}`,
    };
}

